import { useContext } from "react";
import { useAuth } from "../auth/useAuth";
import { Domains } from "../data/Domains";
import { HttpMethods } from "../data/HttpMethods";
import { NotificationTypes } from "../data/NotificationTypes";
import { VillageRuleDto } from "../dtos/VillageRuleDto";
import { VillageRulesDto } from "../dtos/VillageRulesDto";
import VillageConsoleContext from "../store/VillageConsoleContext";
import { getHttpOptions, fetchData, getHttpOptionsTokenOnly } from "../utils/http.util";


export const useVillageRules = ( ): {

    getFunctionKey( ): Promise< string | null >
    , getVillageRule ( domain: Domains, villageRuleId: number ) : Promise< VillageRuleDto | undefined >
    , getVillageRules( domain: Domains ) : Promise<VillageRulesDto[]>

} => {

    const { functionKey, setNotificationText, setNotificationType, setFunctionKey } = useContext( VillageConsoleContext );
    const { getIdToken } = useAuth( );

    const getFunctionKey = async( ): Promise< string | null > => {


        const idToken: string = await getIdToken( );
        const options = getHttpOptionsTokenOnly ( idToken, HttpMethods.Get );
        const query = `${process.env.REACT_APP_API_URL}/functionKey`;

        const response = await fetchData( options, query  );
        
        if ( response.response === null ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( 'Error fetching security info' );

            return null;

        }

        const functionKey: string = await response.response?.text( );
        setFunctionKey( functionKey );
        return functionKey;

    };
    
    
    const getVillageRules = async ( domain: Domains ): Promise<VillageRulesDto[]> => {

        const query = `${process.env.REACT_APP_API_URL}/rules?domain=${ domain }`;
        const idToken: string = await getIdToken( );
        const options = getHttpOptions ( idToken, functionKey!, HttpMethods.Get );

        const response = await fetchData( options, query  );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( `Error fetching village rules for ${ domain }` );

            return [ ];

        }

        return await response.response?.json( );
  
    };


    const getVillageRule = async ( domain: Domains, villageRuleId: number ): Promise< VillageRuleDto | undefined > => {

        const query = `${process.env.REACT_APP_API_URL}/rule?domain=${ domain }&villageRuleId=${villageRuleId}`;
        const idToken: string = await getIdToken( );
        const options = getHttpOptions ( idToken, functionKey!, HttpMethods.Get );

        const response = await fetchData( options, query  );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( `Error fetching village rules ${villageRuleId} for ${domain}` );
            return undefined;

        }

        return await response.response?.json( );

    };


    return {

        getFunctionKey
        , getVillageRule
        , getVillageRules

    };

}; 